var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{class:['content', 'content-loading']},[_c('Loading',{attrs:{"loading":!this.path},on:{"finished-animation":function($event){return _vm.$router.push(_vm.path);}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }